export class ExclusiveOperationsQueue {
  private pendingOperationPromise: Promise<void> | null = null
  private queue = new Array<() => Promise<void>>()

  private startNextOperationIfNeeded(): void {
    if (this.pendingOperationPromise) {
      // operation runnning, the finally block will trigger next operation when needed
      return
    }
    if (this.queue.length === 0) {
      // nothing to start
      return
    }
    const [operation] = this.queue.splice(0, 1)
    this.pendingOperationPromise = operation()
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- fire-and-forget queue drain: finally chains the next operation
    this.pendingOperationPromise.finally(() => {
      this.pendingOperationPromise = null
      this.startNextOperationIfNeeded()
    })
  }

  run<T>(asyncFunction: () => Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.queue.push(() => asyncFunction().then(resolve, reject))
      this.startNextOperationIfNeeded()
    })
  }

  /**
   * Wait for the queue to be empty (no pending operations and no queued operations)
   */
  async waitForEmpty(): Promise<void> {
    // If there's a pending operation, wait for it to complete
    if (this.pendingOperationPromise) {
      await this.pendingOperationPromise
    }

    // If there are queued operations, wait for them to complete
    while (this.queue.length > 0) {
      await new Promise<void>((resolve) => {
        const checkQueue = () => {
          if (this.queue.length === 0 && !this.pendingOperationPromise) {
            resolve()
          } else {
            setTimeout(checkQueue, 10)
          }
        }
        checkQueue()
      })
    }
  }
}
